import {Component, Inject, PLATFORM_ID} from '@angular/core';
import {AuthRedirectService} from '@spartacus/core';
import {ActivatedRoute} from '@angular/router';
import {isPlatformBrowser} from '@angular/common';
import {LoadingPageComponent} from '@dcp/configurator';

declare global {
  interface Window {
    uidBaselineSettings: any;
    baseline: {
      signOutCallback: () => void;
      signOut: () => void;
      signInCallback: () => void;
      signIn: () => void;
    };
  }
}

@Component({
  selector: 'dcp-baseline',
  templateUrl: './baseline.component.html',
  styleUrls: ['./baseline.component.scss'],
  imports: [LoadingPageComponent],
})
export class BaselineComponent {
  constructor(
    @Inject(PLATFORM_ID) public platformId: string,
    protected authRedirectService: AuthRedirectService,
    private activatedRoute: ActivatedRoute,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      const params = this.activatedRoute.snapshot.params;
      const action = params?.action;
      if (action === 'login') {
        window.uidBaselineSettings.action = 'silentSignInCallback';
      } else if (action === 'logout') {
        window.uidBaselineSettings.action = 'redirectSignOutCallback';
        this.authRedirectService.redirect();
      }
    }
  }
}
